function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Ajv from "ajv";
import en from "ajv-i18n/localize/en";
import fi from "ajv-i18n/localize/fi";
import sv from "ajv-i18n/localize/sv";
import toPath from "lodash/toPath";
import { deepEquals, getDefaultFormState, isObject, mergeObjects } from "./utils";
import sift from "sift";
var ajv = createAjvInstance();
var localize = {
  en: en,
  fi: fi,
  sv: sv
};
var formerCustomFormats = null;
var formerMetaSchema = null;
var ROOT_SCHEMA_PREFIX = "__rjsf_rootSchema";

function createAjvInstance() {
  var ajv = new Ajv({
    errorDataPath: "property",
    allErrors: true,
    multipleOfPrecision: 8,
    schemaId: "auto",
    unknownFormats: "ignore",
    messages: false
  }); // add custom formats

  ajv.addFormat("data-url", /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/);
  ajv.addFormat("color", /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/);
  return ajv;
}

function toErrorSchema(errors) {
  // Transforms a ajv validation errors list:
  // [
  //   {property: ".level1.level2[2].level3", message: "err a"},
  //   {property: ".level1.level2[2].level3", message: "err b"},
  //   {property: ".level1.level2[4].level3", message: "err b"},
  // ]
  // Into an error tree:
  // {
  //   level1: {
  //     level2: {
  //       2: {level3: {errors: ["err a", "err b"]}},
  //       4: {level3: {errors: ["err b"]}},
  //     }
  //   }
  // };
  if (!errors.length) {
    return {};
  }

  return errors.reduce(function (errorSchema, error) {
    var property = error.property,
        message = error.message;
    var path = toPath(property);
    var parent = errorSchema; // If the property is at the root (.level1) then toPath creates
    // an empty array element at the first index. Remove it.

    if (path.length > 0 && path[0] === "") {
      path.splice(0, 1);
    }

    var _iterator = _createForOfIteratorHelper(path.slice(0)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var segment = _step.value;

        if (!(segment in parent)) {
          parent[segment] = {};
        }

        parent = parent[segment];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (Array.isArray(parent.__errors)) {
      // We store the list of errors for this node in a property named __errors
      // to avoid name collision with a possible sub schema field named
      // "errors" (see `validate.createErrorHandler`).
      parent.__errors = parent.__errors.concat(message);
      parent.property = property;
    } else {
      if (message) {
        parent.__errors = [message];
        parent.property = property;
      }
    }

    return errorSchema;
  }, {});
}

export function toErrorList(errorSchema) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";

  // XXX: We should transform fieldName as a full field path string.
  if (_typeof(errorSchema) !== "object" || errorSchema === null) {
    return [];
  }

  var errorList = [];

  if ("__errors" in errorSchema) {
    errorList = errorList.concat(errorSchema.__errors.map(function (stack) {
      return {
        stack: "".concat(stack),
        property: errorSchema.property
      };
    }));
  }

  return Object.keys(errorSchema).reduce(function (acc, key) {
    if (key !== "__errors") {
      acc = acc.concat(toErrorList(errorSchema[key], key));
    }

    return acc;
  }, errorList);
}

function createErrorHandler(formData) {
  var handler = {
    // We store the list of errors for this node in a property named __errors
    // to avoid name collision with a possible sub schema field named
    // "errors" (see `utils.toErrorSchema`).
    __errors: [],
    addError: function addError(message) {
      this.__errors.push(message);
    }
  };

  if (isObject(formData)) {
    return Object.keys(formData).reduce(function (acc, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, createErrorHandler(formData[key])));
    }, handler);
  }

  if (Array.isArray(formData)) {
    return formData.reduce(function (acc, value, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, createErrorHandler(value)));
    }, handler);
  }

  return handler;
}

function unwrapErrorHandler(errorHandler) {
  var currentKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (_typeof(errorHandler) !== "object" || errorHandler === null) {
    return errorHandler;
  }

  return Object.keys(errorHandler).reduce(function (acc, key) {
    if (key === "addError") {
      return acc;
    }

    if (key === "__errors" && Array.isArray(errorHandler[key]) && errorHandler[key].length > 0) {
      var errorObj = _defineProperty({}, key, errorHandler[key]);

      if (currentKey !== null) {
        errorObj.property = "['".concat(currentKey, "']");
      }

      return _objectSpread(_objectSpread({}, acc), errorObj);
    }

    var processed = unwrapErrorHandler(errorHandler[key], key);

    if (processed && Object.keys(processed).length > 0) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, processed));
    }

    return acc;
  }, {});
}
/**
 * Transforming the error output from ajv to format used by jsonschema.
 * At some point, components should be updated to support ajv.
 */


function transformAjvErrors() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (errors === null) {
    return [];
  }

  return errors.map(function (e) {
    var dataPath = e.dataPath,
        keyword = e.keyword,
        message = e.message,
        params = e.params,
        schemaPath = e.schemaPath;
    var property = "".concat(dataPath); // put data in expected format

    return {
      name: keyword,
      property: property,
      message: message,
      params: params,
      // specific to ajv
      stack: "".concat(property, " ").concat(message).trim(),
      schemaPath: schemaPath
    };
  });
}

function addAnyOfAdditionalParams() {
  var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (errors === null) {
    return [];
  }

  var anyOfErrorPaths = errors.filter(function (error) {
    return error.keyword === "anyOf";
  }).map(function (error) {
    return error.dataPath;
  });
  var modifiedErrors = errors.map(function (error) {
    if (anyOfErrorPaths.some(function (path) {
      return error.dataPath.startsWith(path);
    }) && (error.keyword === "required" || error.keyword === "minLength" && error.params.limit === 1 || error.keyword === "minItems" && error.params.limit === 1)) {
      return _objectSpread(_objectSpread({}, error), {}, {
        keyword: "anyOfRequired"
      });
    } else {
      return error;
    }
  });
  return modifiedErrors;
}

var requiredExists = function requiredExists(formData, fieldConfig) {
  var _fieldConfig$filter, _fieldConfig$filter$s;

  return sift(fieldConfig === null || fieldConfig === void 0 ? void 0 : (_fieldConfig$filter = fieldConfig.filter) === null || _fieldConfig$filter === void 0 ? void 0 : (_fieldConfig$filter$s = _fieldConfig$filter.show) === null || _fieldConfig$filter$s === void 0 ? void 0 : _fieldConfig$filter$s.query)(formData);
};

var transformRepeatableFormgroups = function transformRepeatableFormgroups(formData, schema) {
  var _schema$items;

  var errorFormdata = formData;

  var errorSchema = _objectSpread(_objectSpread({}, schema), {}, {
    properties: {}
  });

  if (schema.type === "object" && schema.properties) {
    for (var key in schema.properties) {
      var _transformRepeatableF = transformRepeatableFormgroups(formData === null || formData === void 0 ? void 0 : formData[key], schema.properties[key]),
          newFormdata = _transformRepeatableF.formData,
          newSchema = _transformRepeatableF.errorSchema;

      errorSchema.properties[key] = newSchema;
      formData[key] = newFormdata;
    }
  } else if (schema.type === "array" && ((_schema$items = schema.items) === null || _schema$items === void 0 ? void 0 : _schema$items.type) === "object") {
    errorSchema.type = "object";
    var newConfig = {};
    errorFormdata = {};

    var items = _objectSpread({}, schema.items);

    var _loop = function _loop(i) {
      var _schema$items2;

      var newSchema = items ? _objectSpread(_objectSpread({}, items), {}, {
        properties: _objectSpread({}, items === null || items === void 0 ? void 0 : items.properties)
      }) : {
        properties: {}
      };
      var required = items !== null && items !== void 0 && items.required ? _toConsumableArray(items.required) : [];

      if ((_schema$items2 = schema.items) !== null && _schema$items2 !== void 0 && _schema$items2.required && schema.items.required.length > 0) {
        var newRequired = schema.items.required.filter(function (key) {
          var _schema$items3, _schema$items3$origin, _schema$items3$origin2, _originalField$filter;

          var originalField = (_schema$items3 = schema.items) === null || _schema$items3 === void 0 ? void 0 : (_schema$items3$origin = _schema$items3.originalConfig) === null || _schema$items3$origin === void 0 ? void 0 : (_schema$items3$origin2 = _schema$items3$origin.elements) === null || _schema$items3$origin2 === void 0 ? void 0 : _schema$items3$origin2.find(function (element) {
            return element.key === key;
          });
          return originalField !== null && originalField !== void 0 && (_originalField$filter = originalField.filter) !== null && _originalField$filter !== void 0 && _originalField$filter.show ? requiredExists(formData[i], originalField) : true;
        });
        newSchema.required = newRequired;
      }

      var removeFromValidationKeys = Object.keys(newSchema.properties).filter(function (key) {
        var _schema$items4, _schema$items4$origin, _schema$items4$origin2, _originalField$filter2;

        var originalField = (_schema$items4 = schema.items) === null || _schema$items4 === void 0 ? void 0 : (_schema$items4$origin = _schema$items4.originalConfig) === null || _schema$items4$origin === void 0 ? void 0 : (_schema$items4$origin2 = _schema$items4$origin.elements) === null || _schema$items4$origin2 === void 0 ? void 0 : _schema$items4$origin2.find(function (element) {
          return element.key === key;
        });
        return originalField !== null && originalField !== void 0 && (_originalField$filter2 = originalField.filter) !== null && _originalField$filter2 !== void 0 && _originalField$filter2.show ? !requiredExists(formData[i], originalField) : false;
      });
      removeFromValidationKeys.forEach(function (key) {
        delete newSchema.properties[key];

        if (required.indexOf(key) >= 0) {
          required.splice(required.indexOf(key), 1);
        }
      });
      newConfig["".concat(i)] = newSchema;
      errorFormdata["".concat(i)] = formData[i];
    };

    for (var i in formData) {
      _loop(i);
    }

    errorSchema.properties = newConfig;
  }

  return {
    formData: errorFormdata,
    errorSchema: errorSchema
  };
};

var addAnyOf = function addAnyOf(schema) {
  var _schema$items5;

  var errorSchema = _objectSpread(_objectSpread({}, schema), {}, {
    properties: {}
  });

  if ((schema === null || schema === void 0 ? void 0 : schema.type) === "array" && (schema === null || schema === void 0 ? void 0 : (_schema$items5 = schema.items) === null || _schema$items5 === void 0 ? void 0 : _schema$items5.type) === "object") {
    errorSchema.items = addAnyOf(schema.items);
  } else if (schema.type === "object" && schema.requireAtLeastOne) {
    var anyOf = [];

    for (var key in schema.properties) {
      if (!schema.properties[key].additionalType || schema.properties[key].additionalType === "consent") {
        var schemaObject = {
          required: ["".concat(key)],
          properties: {}
        };

        if (schema.properties[key].type === "string") {
          schemaObject.properties[key] = {
            minLength: 1
          };
        } else if (schema.properties[key].type === "array") {
          schemaObject.properties[key] = {
            minItems: 1
          };
        }

        anyOf.push(schemaObject);
      }
    }

    errorSchema = _objectSpread(_objectSpread({}, schema), {}, {
      anyOf: anyOf
    });
  } else if (schema.type === "object" && schema.properties) {
    for (var _key in schema.properties) {
      errorSchema.properties[_key] = addAnyOf(schema.properties[_key]);
    }
  }

  return errorSchema;
};
/**
 * This function processes the formData with a user `validate` contributed
 * function, which receives the form data and an `errorHandler` object that
 * will be used to add custom validation errors for each field.
 */


export default function validateFormData(formData, schema, customValidate, transformErrors) {
  var additionalMetaSchemas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var customFormats = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var intl = arguments.length > 6 ? arguments[6] : undefined;
  // Include form data with undefined values, which is required for validation.
  var rootSchema = schema;
  formData = getDefaultFormState(schema, formData, rootSchema, true);
  var newMetaSchemas = !deepEquals(formerMetaSchema, additionalMetaSchemas);
  var newFormats = !deepEquals(formerCustomFormats, customFormats);

  if (newMetaSchemas || newFormats) {
    ajv = createAjvInstance();
  } // add more schemas to validate against


  if (additionalMetaSchemas && newMetaSchemas && Array.isArray(additionalMetaSchemas)) {
    ajv.addMetaSchema(additionalMetaSchemas);
    formerMetaSchema = additionalMetaSchemas;
  } // add more custom formats to validate against


  if (customFormats && newFormats && isObject(customFormats)) {
    Object.keys(customFormats).forEach(function (formatName) {
      ajv.addFormat(formatName, customFormats[formatName]);
    });
    formerCustomFormats = customFormats;
  }

  var removeDataFromValidation = function removeDataFromValidation(elements, required, formData, objectList, handleFalseAsUndefined) {
    for (var key in elements) {
      var element = elements[key];

      if (handleFalseAsUndefined && (element === null || element === void 0 ? void 0 : element.type) === "boolean" && (element === null || element === void 0 ? void 0 : element.additionalType) !== "consent" && formData[key] === false) {
        formData[key] = undefined;
      } else if ((element === null || element === void 0 ? void 0 : element.type) === "object" && (element === null || element === void 0 ? void 0 : element.format) !== "table") {
        removeDataFromValidation(element.properties, element.required, formData[key], false, element.handleFalseAsUndefined !== undefined ? element.handleFalseAsUndefined : false);
      } else if ((element === null || element === void 0 ? void 0 : element.type) === "array" && (element === null || element === void 0 ? void 0 : element.items.type) === "object") {
        removeDataFromValidation(element.items.properties, element.items.required, formData[key], true, element.handleFalseAsUndefined !== undefined ? element.handleFalseAsUndefined : false);
      } else if (!(required !== null && required !== void 0 && required.includes(key)) && (element === null || element === void 0 ? void 0 : element.type) === "array" && ((element === null || element === void 0 ? void 0 : element.items.type) !== "object" || (element === null || element === void 0 ? void 0 : element.items.format) === "table") && !(element !== null && element !== void 0 && element.items.pattern) && !(element !== null && element !== void 0 && element.items.minimum) && !(element !== null && element !== void 0 && element.items.maximum) && !(element !== null && element !== void 0 && element.items.maxLength)) {
        // do not validate these fields
        if (objectList) {
          var _iterator2 = _createForOfIteratorHelper(formData),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var formDatum = _step2.value;
              delete formDatum[key];
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        } else {
          delete formData[key];
        }
      }
    }
  };

  removeDataFromValidation(schema.properties, schema.required, formData, false, false);
  var anyOfSchema = addAnyOf(schema);

  var _transformRepeatableF2 = transformRepeatableFormgroups(formData, anyOfSchema),
      newFormData = _transformRepeatableF2.formData,
      newSchema = _transformRepeatableF2.errorSchema;

  var validationError = null;

  try {
    //ajv.validate(anyOfSchema, formData);
    ajv.validate(newSchema, newFormData);
  } catch (err) {
    validationError = err;
  }

  localize[intl.locale.split("-")[0]](ajv.errors);
  var errors = addAnyOfAdditionalParams(ajv.errors);
  errors = transformAjvErrors(errors); // Clear errors to prevent persistent errors, see #1104

  ajv.errors = null;
  var noProperMetaSchema = validationError && validationError.message && typeof validationError.message === "string" && validationError.message.includes("no schema with key or ref ");

  if (noProperMetaSchema) {
    errors = [].concat(_toConsumableArray(errors), [{
      stack: validationError.message
    }]);
  }

  if (typeof transformErrors === "function") {
    errors = transformErrors(errors);
  }

  var errorSchema = toErrorSchema(errors);

  if (noProperMetaSchema) {
    errorSchema = _objectSpread(_objectSpread({}, errorSchema), {
      $schema: {
        __errors: [validationError.message]
      }
    });
  }

  if (typeof customValidate !== "function") {
    return {
      errors: errors,
      errorSchema: errorSchema
    };
  }

  var errorHandler = customValidate(formData, createErrorHandler(formData));
  var userErrorSchema = unwrapErrorHandler(errorHandler);
  var newErrorSchema = mergeObjects(errorSchema, userErrorSchema, true); // XXX: The errors list produced is not fully compliant with the format
  // exposed by the jsonschema lib, which contains full field paths and other
  // properties.

  var newErrors = toErrorList(newErrorSchema);
  return {
    errors: newErrors,
    errorSchema: newErrorSchema
  };
}
/**
 * Recursively prefixes all $ref's in a schema with `ROOT_SCHEMA_PREFIX`
 * This is used in isValid to make references to the rootSchema
 */

export function withIdRefPrefix(schemaNode) {
  var obj = schemaNode;

  if (schemaNode.constructor === Object) {
    obj = _objectSpread({}, schemaNode);

    for (var key in obj) {
      var value = obj[key];

      if (key === "$ref" && typeof value === "string" && value.startsWith("#")) {
        obj[key] = ROOT_SCHEMA_PREFIX + value;
      } else {
        obj[key] = withIdRefPrefix(value);
      }
    }
  } else if (Array.isArray(schemaNode)) {
    obj = _toConsumableArray(schemaNode);

    for (var i = 0; i < obj.length; i++) {
      obj[i] = withIdRefPrefix(obj[i]);
    }
  }

  return obj;
}
/**
 * Validates data against a schema, returning true if the data is valid, or
 * false otherwise. If the schema is invalid, then this function will return
 * false.
 */

export function isValid(schema, data, rootSchema) {
  try {
    // add the rootSchema ROOT_SCHEMA_PREFIX as id.
    // then rewrite the schema ref's to point to the rootSchema
    // this accounts for the case where schema have references to models
    // that lives in the rootSchema but not in the schema in question.
    return ajv.addSchema(rootSchema, ROOT_SCHEMA_PREFIX).validate(withIdRefPrefix(schema), data);
  } catch (e) {
    return false;
  } finally {
    // make sure we remove the rootSchema from the global ajv instance
    ajv.removeSchema(ROOT_SCHEMA_PREFIX);
  }
}